We do not share any email addresses with third parties. Email addresses are used for transactional emails (e.g. purchase or invoice emails), to log in to the dashboard, and to send abandoned cart recovery emails to help potential customers complete their purchase.

---

# Privacy Policy

Last updated: November 30, 2025

This Privacy Policy describes how Xplat-soft s.r.o. (the "Site", "we", "us", or "our") collects, uses, and discloses your personal information when you visit, use our services, our npm packages, or make a purchase from universal-sign-in.com (the "Site" or "Website") or otherwise communicate with us (collectively, the "Services"). For purposes of this Privacy Policy, "you" and "your" means you as the user of the Services, whether you are a customer, website visitor, or another individual whose information we have collected pursuant to this Privacy Policy.

Please read this Privacy Policy carefully. By using and accessing any of the Services, you agree to the collection, use, and disclosure of your information as described in this Privacy Policy. If you do not agree to this Privacy Policy, please do not use or access any of the Services.

## Changes to This Privacy Policy

We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on the Site, update the "Last updated" date and take any other steps required by applicable law.

## How We Collect and Use Your Personal Information

To provide the Services, we collect personal information about you as set out below.

In addition to the specific uses set out below, we may use information we collect about you to communicate with you, provide the Services, comply with any applicable legal obligations, enforce any applicable terms of service, and to protect or defend the Services, our rights, and the rights of our users or others.

## What Personal Information We Collect

While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:

- Email
- Name
- GitHub username
- Cookies
- Usage Data

We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other diagnostic data.

## Use of Data

We use the collected data for various purposes:

- To provide and maintain the Service
- To provide customer care
- To notify you about changes to our Service
- To allow you to participate in interactive features of our Service when you choose to do so
- To provide analysis or valuable information so that we can improve the Service
- To monitor the usage of the Service
- To detect, prevent and address technical issues
- To send abandoned cart recovery emails when you begin but do not complete a purchase

## Transfer of data

Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.

Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.

## Purchases

All purchases made through the Website are processed by a third party payment processor, [Creem](https://www.creem.io/). Creem may ask you for personal and/or non-personal information, such as your name, address, email address, credit card information, or other Personal Information. Creem has a [privacy policy](https://www.creem.io/privacy) that describes their collection and use of personal information.

Creem provides us with certain information relating to purchases made by visitors to the Website. The information may include details of the purchase such as the date, amount paid, and product purchased, name and email. The purchase information may be linked to the Personal Information you provide to us (typically limited to your email address, as stated above). Creem does not supply us with any credit card information.

Creem also facilitates abandoned cart recovery by tracking checkout sessions and sending automated reminder emails to users who begin but do not complete a purchase. These emails are sent on our behalf through Creem's platform.

## Disclosure Of Data

### Legal Requirements

We may disclose your Personal Data in the good faith belief that such action is necessary to:

- To comply with a legal obligation
- To protect and defend the rights or property of Xplat-soft
- To prevent or investigate possible wrongdoing in connection with the Service
- To protect the personal safety of users of the Service or the public
- To protect against legal liability

### Security Of Data and Storage of Your Information

The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.

We store customer data in the EU.

## Analytics

We may use third-party Service Providers to monitor and analyze the use of our Service.

## Children's Data

The Service does not address anyone under the age of 18 ("Children").

We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.

## Contact

If you have any questions about this Privacy Policy please contact us via the 'Contact Us' page on this website.
